Registrable = require 'mixins/registrable'
HandleTextChange = require 'mixins/handle-text-change'

App.SmTextAreaComponent = Em.TextArea.extend [
  Registrable
  HandleTextChange
  Em.I18n.TranslateableAttributes,
  Em.I18n.TranslateableProperties
]...,
  classNames: ['sm-text-area']
  classNameBindings: ['size', 'type']
